import React from 'react'

import services_image1 from "../assets/services_image1.jpg"
import services_image2 from "../assets/services_image2.jpg"
import services_image3 from "../assets/services_image3.jpg"

const Services = () => {
    const services = [
        { img: `${services_image1}`, color: "#75ce36", heading: "Learning & Fun", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
        { img: `${services_image2}`, color: "#d766ff", heading: "Healthy Meals", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
        { img: `${services_image3}`, color: "#ffb132", heading: "Children Safety", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
        { img: `${services_image3}`, color: "#ff6666", heading: "Children Safety", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
    ]
    return (
        <div>
            <div className='service_container bg-white mt-[50px] '>
                <div className='heading_container text-center'>
                    <p className='text-main-color font-sans font-semibold text-[21px]'>Service We Provide</p>
                    <h3 className='text-[32px] text-[#161616] font-semibold'>Providing Good Qualities For</h3>
                    <h3 className='text-[32px] text-[#161616] font-semibold'>Your Loving Kids</h3>
                </div>

                <div className='card_container' >


                    {
                        services && services.map((item, index) => {
                            return (
                                <div className='card w-[250px]  '>
                                    <div style={{ backgroundColor: `${item.color}` }} className={` px-[20px] py-[30px] text-white relative rounded-lg`}>
                                        <div className='rounded-full w-[100px] h-[100px] absolute top-[-50px] left-0 right-0 ml-auto mr-auto'>
                                            <img className='rounded-full w-full h-full' src={item.img} alt="" />
                                        </div>
                                        <div className='mt-[40px] text-center'>
                                            <h3 className='text-[20px] font-semibold'>{item.heading}</h3>
                                            <p className='text-[16px] font-normal'>
                                                {item.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }



                </div>

            </div>
        </div>
    )
}

export default Services